import { contentActionsService } from '../../../utils/ContentActionsService/ContentActionsService';
import { ContentType, FieldName } from '../../../utils/ContentActionsService/types';
import { EventSource } from '../../../utils/analyticsService';

export const useTrackEvents = (params: {
    id?: string;
    screen: EventSource;
    mode: 'edit' | 'create';
}) => {
    const relatedContentType = params.mode === 'edit' ? ContentType.COLLECTION : ContentType.POST;
    const id = params.id ?? '';

    const trackDisplayNameEdit = (newValue: string) => {
        contentActionsService.trackCollectionEdit({
            id,
            newValue,
            fieldName: FieldName.DISPLAY_NAME,
            screen: params.screen,
            relatedContentType,
        });
    };

    const trackIsPublicEdit = (oldValue: boolean, newValue: boolean) => {
        contentActionsService.trackCollectionEdit({
            id,
            newValue: newValue.toString(),
            oldValue: oldValue.toString(),
            fieldName: FieldName.IS_PUBLIC,
            screen: params.screen,
            relatedContentType,
        });
    };

    const trackShowInFeedEdit = (oldValue: boolean, newValue: boolean) => {
        contentActionsService.trackCollectionEdit({
            id,
            newValue: newValue.toString(),
            oldValue: oldValue.toString(),
            fieldName: FieldName.SHOW_IN_FEED,
            screen: params.screen,
            relatedContentType,
        });
    };

    return { trackDisplayNameEdit, trackIsPublicEdit, trackShowInFeedEdit };
};
